/** ID del pixel de Meta para Kit Maestro de Biodescodificación. */
export const META_PIXEL_ID = '928392859622651';

type PixelParams = Record<string, string | number>;

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

/** Inyecta fbevents.js e inicializa el pixel una sola vez. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return;

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq && fbq.callMethod) {
        fbq.callMethod(...args);
      } else if (fbq) {
        fbq.queue = fbq.queue || [];
        fbq.queue.push(args);
      }
    } as NonNullable<Window['fbq']>;

    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.push = fbq;
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  if (document.getElementById('meta-pixel-noscript') === null) {
    const noscript = document.createElement('noscript');
    noscript.id = 'meta-pixel-noscript';
    const image = document.createElement('img');
    image.height = 1;
    image.width = 1;
    image.style.display = 'none';
    image.alt = '';
    image.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(image);
    document.body.appendChild(noscript);
  }

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

/** Dispara un evento estándar del pixel. */
export function trackPixelEvent(event: string, params?: PixelParams): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}
